import { Box } from '@mui/material';
import { formatTime } from '@utils/time/timeUtils';

export default function TranscriptWord({ word, isActive, onClick }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      aria-label={`Jump to ${formatTime(word.start)}`}
      sx={{
        display: 'inline',
        cursor: 'pointer',
        bgcolor: isActive ? 'primary.light' : 'transparent',
        color: isActive ? 'primary.contrastText' : 'inherit',
        borderRadius: 0.5,
        px: { xs: 0.2, sm: 0.25 },
        mr: { xs: 0.35, sm: 0.5 },
        transition: 'all 0.15s',
        whiteSpace: 'normal',
        wordBreak: 'normal',
        appearance: 'none',
        border: 0,
        font: 'inherit',
        margin: 0,
        lineHeight: 'inherit',
        touchAction: 'manipulation',
        '&:hover': {
          bgcolor: isActive ? 'primary.light' : 'action.hover'
        },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 2
        }
      }}
    >
      {word.word}{' '}
    </Box>
  );
}
